// material ui
import { Stack } from '@mui/material';

// api
import { ReadAlarmDto } from '@/api/generated/recalc/endpoints/v1/alarms';

// relative
import InsufficientData from './alarmSubtype/InsufficientData';
import SeepLeakageDetected from './alarmSubtype/SeepLeakageDetected';

function renderAlarmSubtype(
  alarmSubType: ReadAlarmDto['AlarmSubtype'],
  metaData: ReadAlarmDto['MetaData'],
  alarm: ReadAlarmDto,
) {
  switch (alarmSubType) {
    case 'SeepLeakageDetected':
      return <SeepLeakageDetected alarm={alarm} />;
    case 'InsufficientData':
      return <InsufficientData alarm={alarm} />;
    default:
      return <pre>{JSON.stringify(metaData, null, 2)}</pre>;
  }
}

const SeepLeakage = ({ alarm }) => {
  return (
    <Stack spacing={2}>
      {renderAlarmSubtype(alarm.AlarmSubtype, alarm.MetaData, alarm)}
    </Stack>
  );
};

export default SeepLeakage;
